import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // ── Auth Layout ──────────────────────────────────────────────────────────
    {
      path: '/auth',
      component: () => import('@/layouts/AuthLayout.vue'),
      children: [
        { path: 'login', name: 'login', component: () => import('@/views/auth/LoginView.vue') },
        { path: 'register', name: 'register', component: () => import('@/views/auth/RegisterView.vue') },
        { path: 'callback', name: 'auth-callback', component: () => import('@/views/auth/CallbackView.vue') },
      ],
    },

    // ── App Layout ────────────────────────────────────────────────────────────
    {
      path: '/',
      component: () => import('@/layouts/AppLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        { path: '', redirect: '/dashboard' },
        { path: 'dashboard', name: 'dashboard', component: () => import('@/views/DashboardView.vue') },
        { path: 'revenue', name: 'revenue', component: () => import('@/views/RevenueView.vue') },
        { path: 'leakages', name: 'leakages', component: () => import('@/views/LeakagesView.vue') },
        { path: 'billing', name: 'billing', component: () => import('@/views/BillingView.vue') },
        { path: 'billing/success', name: 'billing-success', component: () => import('@/views/BillingSuccessView.vue') },
        { path: 'integrations', name: 'integrations', component: () => import('@/views/IntegrationsView.vue') },
        { path: 'settings', name: 'settings', component: () => import('@/views/SettingsView.vue') },
        { path: 'team', name: 'team', component: () => import('@/views/TeamView.vue') },
      ],
    },

    // ── Fallback ──────────────────────────────────────────────────────────────
    { path: '/:pathMatch(.*)*', redirect: '/dashboard' },
  ],
});

// ── Auth Guard ────────────────────────────────────────────────────────────────
router.beforeEach((to) => {
  const auth = useAuthStore();
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } };
  }
  if ((to.name === 'login' || to.name === 'register') && auth.isAuthenticated) {
    return { name: 'dashboard' };
  }
});

export default router;
